import React from 'react';
import CallToAction from '../CallToAction/CallToAction';
import { getInlineStyles } from '../../store/designStore';

const HeroCTA = ({ ctaConfig }) => {
    if (!ctaConfig?.hasCTA) return null;
    const titleText = ctaConfig.title?.text;
    const bodyText = ctaConfig.body?.text;
    const isButtonVisible = ctaConfig.button?.isVisible ?? true;
    const buttonLinkUrl = ctaConfig.button?.linkUrl;
    const buttonText = ctaConfig.button?.text;
    const isButtonOutlined = ctaConfig.button?.isOutlined ?? false;
    const buttonColor = ctaConfig.button?.color;
    const titleStyle = ctaConfig.title?.style;
    const bodyStyle = ctaConfig.body?.style;
    const buttonStyle = ctaConfig.button?.style;

    return (
        <CallToAction
            headline={titleText}
            copy={bodyText}
            buttonVisibility={isButtonVisible}
            linkUrl={buttonLinkUrl}
            buttonText={buttonText}
            outline={isButtonOutlined}
            buttonColor="primary"
            btnClass="anl_cta--keyvisual--btn-main"
            headlineStyle={getInlineStyles(titleStyle)}
            copyStyle={getInlineStyles(bodyStyle)}
            buttonStyle={{
                backgroundColor: isButtonOutlined ? 'transparent' : buttonColor || undefined,
                borderColor: buttonColor || undefined,
                color: isButtonOutlined && buttonColor ? buttonColor : undefined,
                ...getInlineStyles(buttonStyle),
            }}
        />
    );
};

export default HeroCTA;
